export default __webpack_public_path__ + "static/media/changeAgentArrow.a9010813.svg";